export const Rights = [
    "WEB_MODULE_COMPENSATION_WRITE"
]
